import { render, staticRenderFns } from "./ProductivityTable.vue?vue&type=template&id=426f937a&"
import script from "./ProductivityTable.vue?vue&type=script&lang=js&"
export * from "./ProductivityTable.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ProductivityTable.vue?vue&type=style&index=0&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDataTable,VIcon})
